// extracted by mini-css-extract-plugin
module.exports = {"bgHeader":"WebStep01IndexPage_bgHeader__0anpz","bgHeaderOpen":"WebStep01IndexPage_bgHeaderOpen__Fn43a"};